(ns ui.elevenlabs.page
  (:require [ui.app-frame :as app-frame]
            ))

(defn render [state]
  (app-frame/app-frame
    state
    [:div
     [:button
      {:on {:click [[:ui/modal-open
                     :modals/elevenlabs-voice-list
                     {} ;; params map
                     ]]}}
      "open modal"]]))

(def page
  {:page-id :pages/elevenlabs
   :route [["ui" "elevenlabs"]]
   :render #'render})
